import { LogLevel, Configuration, RedirectRequest } from '@azure/msal-browser';

/**
 * DevNonProd Environment Configuration
 * Azure AD B2C Authentication (for external candidates)
 * Azure AD Corporate Authentication (for Microsoft employees)
 */

// Azure AD B2C Configuration - for external candidates
const b2cTenantName = 'hroffboarding'; // e.g., 'contosob2c'
const b2cTenantId = '332a0960-e037-4f11-bf0f-6a64a4c9b727'; // Your B2C tenant domain
const b2cPolicyName = 'B2C_1_onboardingDev'; // Your sign-up/sign-in policy name

// Azure AD Corporate Configuration - for Microsoft employees
const aadTenantId = '72f988bf-86f1-41af-91ab-2d7cd011db47'; // Microsoft corporate tenant

export const msalConfig: Configuration = {
    auth: {
        clientId: '6f4223f0-2989-4df6-940d-f53bc330330f', // Replace with your B2C app client ID
        authority: `https://loginnewhirehub.microsoft.com/${b2cTenantId}/${b2cPolicyName}`,
        knownAuthorities: [`${b2cTenantName}.b2clogin.com`, 'loginnewhirehub.microsoft.com'],
        redirectUri: 'https://onboarding-client-dev-ghhjdphbg7dvchcx.b01.azurefd.net/auth/b2c', // TODO: Update with actual DevNonProd URL
        postLogoutRedirectUri: '/',
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

// Azure AD Corporate MSAL Configuration for Microsoft employees
export const msalConfigCorporate: Configuration = {
    auth: {
        clientId: '93a90b18-ee1d-49f5-a934-c8f2cca5a2fc', 
        authority: `https://login.microsoftonline.com/${aadTenantId}`,
        redirectUri: 'https://onboarding-client-dev-ghhjdphbg7dvchcx.b01.azurefd.net/auth/corporate', 
        postLogoutRedirectUri: '/',
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

// B2C scopes for external candidates
const b2cScopes = [
    'https://hroffboarding.onmicrosoft.com/6f4223f0-2989-4df6-940d-f53bc330330f/user-impersonation',
];

// Corporate scopes for Microsoft employees
const corporateScopes = [
    'api://93a90b18-ee1d-49f5-a934-c8f2cca5a2fc/default'
];

export const getLoginRequest = (authProvider: 'b2c' | 'corporate'): RedirectRequest => {
    const scopes = authProvider === 'corporate' ? corporateScopes : b2cScopes;
    return { scopes };
};

export const loginRequest: RedirectRequest = {
    scopes: b2cScopes,
};

export const loginRequestCorporate: RedirectRequest = {
    scopes: corporateScopes,
};

// DevNonProd-specific settings
export const apiConfig = {
  baseUrl: 'https://onboarding-client-dev-ghhjdphbg7dvchcx.b01.azurefd.net',
  timeout: 30000,
};

export const appConfig = {
    enableDebugMode: true,
    enableAnalytics: true,
    logLevel: LogLevel.Verbose,
    applicationInsightsConnectionString:
        'InstrumentationKey=0a4741af-88f0-4448-88dd-c62d4904d65f;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=034c0418-43c3-44cc-b079-cdce4d7d48af', 
};
